import { useMemo } from 'react';

export function useDropdown({ value, options, onChange }) {
  const { byLabel, byValue, data } = useMemo(
    () =>
      options.reduce(
        (acc, option) => {
          acc.byLabel[option.label] = option;
          acc.byValue[option.value] = option;
          acc.data.push(option.label);

          return acc;
        },
        { byLabel: {}, byValue: {}, data: [] }
      ),
    [options]
  );
  const title = byValue[value.span]?.label;
  const selectItem = (label) => {
    const option = byLabel[label];

    if (option) {
      onChange({ span: option.value });
    }
  };

  return {
    title,
    data,
    selectItem,
  };
}
